export const SUCCESS_GET_ALL_CLIENTS = 'SUCCESS_GET_ALL_CLIENTS';
export const FAILED_GET_ALL_CLIENTS = 'FAILED_GET_ALL_CLIENTS';
export const SUCCESS_CREATE_CLIENT = 'SUCCESS_CREATE_CLIENT';
export const FAILED_CREATE_CLIENT = 'FAILED_CREATE_CLIENT';
export const SUCCESS_UPDATE_CLIENT = 'SUCCESS_UPDATE_CLIENT';
export const FAILED_UPDATE_CLIENT = 'FAILED_UPDATE_CLIENT';
export const SUCCESS_GET_CLIENT = 'SUCCESS_GET_CLIENT';
export const FAILED_GET_CLIENT = 'FAILED_GET_CLIENT';
export const SUCCESS_GET_CLIENT_FPS = 'SUCCESS_GET_CLIENT_FPS';
export const FAILED_GET_CLIENT_FPS = 'FAILED_GET_CLIENT_FPS';
export const SUCCESS_SAVE_CLIENT_FPS = 'SUCCESS_SAVE_CLIENT_FPS';
export const FAILED_SAVE_CLIENT_FPS = 'FAILED_SAVE_CLIENT_FPS';
export const SUCCESS_GET_SUBCLIENTS = 'SUCCESS_GET_SUBCLIENTS';
export const FAILED_GET_SUBCLIENTS = 'FAILED_GET_SUBCLIENTS';
export const SUCCESS_UPDATE_SUBCLIENT = 'SUCCESS_UPDATE_SUBCLIENT';
export const FAILED_UPDATE_SUBCLIENT = 'FAILED_UPDATE_SUBCLIENT';



// WEBPACK FOOTER //
// ./src/state/constants/clientConstants.js